import { useState, useCallback } from "react";

/**
 * 🛰️ GRAPH CONTROLLER
 * Manages Nodes and Edges for any domain (Corporate, ESG, etc.)
 */
export const useGraphController = () => {
    const [nodes, setNodes] = useState([]);
    const [edges, setEdges] = useState([]);

    const setGraphData = useCallback((newNodes, newEdges) => {
        setNodes(newNodes);
        setEdges(newEdges);
    }, []);

    return { nodes, edges, setGraphData };
};